







































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { getMyAlpacas, getBreedingAlpacas, getBreedingOtherAlpacas, getQuadAlpacas, getMyOtherAlpacas } from '@/backend/requests';
import { OrderBy } from '@/backend/type';
import { Alpaca } from '@/backend/type';
import { ROUTE_ADOPT } from '@/router';

@Component({
  components: {
    AlpacaCard,
    AlpacaBtn,
  },
})
export default class MyAlpacas extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public type!: string;

  @Prop({
    required: false,
    type: Number,
  })
  public depId!: number;

  @Prop({
    required: false,
  })
  public selectedAlpacas!: string[];

  public page: number = 1;
  public curSort: OrderBy = 'energy';
  public order: 1 | -1 = -1;
  public myAlpacas: Alpaca[] = [];
  public offset: number = 0;
  public limit: number = 20;
  public totalAlpacas: number = 0;
  public loaded: boolean = false;

  get account() {
    return this.$store.getters.getAccount;
  }

  get hasAlpacas() {
    return this.totalAlpacas !== 0;
  }

  get hasSelect() {
    return (
      [
        'assignSquadAlpacas',
        'recallSquadAlpacas',
        'recycleAlpacas',
      ].indexOf(this.type) !== -1);
  }

  get hasLink() {
    return (
      [
        'myAlpacas',
        'otherAlpacas',
      ].indexOf(this.type) !== -1);
  }

  get pageNum() {
    if (this.totalAlpacas % this.limit === 0) {
      return this.totalAlpacas / this.limit;
    }
    return Math.floor(this.totalAlpacas / this.limit) + 1;
  }

  get curSortIsAge() {
    return this.curSort === 'age';
  }

  get curSortIsEnergy() {
    return this.curSort === 'energy';
  }

  get curSortIsId() {
    return this.curSort === 'id';
  }

  get hasBreedingFees() {
    return (
      [
        'breedingMyAlpacas',
        'breedingOtherAlpacas',
      ].indexOf(this.type) !== -1);
  }

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  public mounted() {
    this.getAlpacas();
  }

  public goAdopt() {
    this.$router.push({name: ROUTE_ADOPT});
  }

  public selectOptioin(option: 'age' | 'energy') {
    this.curSort = option;
    this.getAlpacas();
  }

  public selectOrder() {
    if (this.order === 1) {
      this.order = -1;
    } else {
      this.order = 1;
    }
    this.getAlpacas();
  }

  public isSelected(id: string) {
    if (this.selectedAlpacas) {
      return this.selectedAlpacas.indexOf(id) !== -1;
    }
    return false;
  }

  public getAlpacas() {
    if (this.type === 'myAlpacas') {
      this.getMyAlpacas();
    }
    if (this.type === 'otherAlpacas') {
      this.getMyOtherAlpacas();
    }
    if (this.type === 'breedingMyAlpacas') {
      this.getBreedingMyAlpacas();
    }
    if (this.type === 'breedingOtherAlpacas') {
      this.getBreedingOtherAlpacas();
    }
    if (this.type === 'farmerAlpacas') {
      this.getMyAlpacas(true);
    }
    if (this.type === 'assignSquadAlpacas') {
      this.getMyAlpacas(true);
    }
    if (this.type === 'recallSquadAlpacas') {
      this.getQuadAlpacas();
    }
    if (this.type === 'recycleAlpacas') {
      this.getMyAlpacas(true);
    }
  }

  public async getMyAlpacas(noEgg?: boolean) {
    const res = await getMyAlpacas(
      this.account,
      this.offset,
      this.limit,
      this.curSort,
      this.order,
      noEgg,
    );
    if (res) {
      this.myAlpacas = res.data.alpacas;
      this.totalAlpacas = res.data.total_count;
    }
    this.loaded = true;
  }

  public async getMyOtherAlpacas() {
    const res = await getMyOtherAlpacas(
      this.account,
      this.offset,
      this.limit,
      this.curSort,
      this.order,
    );
    if (res) {
      this.myAlpacas = res.data.alpacas;
      this.totalAlpacas = res.data.total_count;
    }
    this.loaded = true;
  }

  public async getBreedingMyAlpacas() {
    const res = await getBreedingAlpacas(
      this.account,
      this.offset,
      this.limit,
      this.curSort,
      this.order,
      this.depId,
    );
    if (res) {
      this.myAlpacas = res.data.alpacas;
      this.totalAlpacas = res.data.total_count;
    }
    this.loaded = true;
  }

  public async getBreedingOtherAlpacas() {
    const res = await getBreedingOtherAlpacas(
      this.account,
      this.offset,
      this.limit,
      this.curSort,
      this.order,
      this.depId,
    );
    if (res) {
      this.myAlpacas = res.data.alpacas;
      this.totalAlpacas = res.data.total_count;
    }
    this.loaded = true;
  }

  public async getQuadAlpacas() {
    const res = await getQuadAlpacas(
      this.account,
      this.curSort,
      this.order,
    );
    if (res) {
      this.myAlpacas = res.data.alpacas;
      this.totalAlpacas = res.data.total_count;
    }
    this.loaded = true;
  }

  public changePage(page: number) {
    this.offset = (page - 1) * this.limit;
    this.getAlpacas();
  }

  public clickAlpacaCard(alpaca: Alpaca) {
    if (!this.hasLink) {
      this.$emit('clickAlpacaCard', alpaca);
    }
    return;
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getAlpacas();
    }
  }
}
